<template>
  <el-popover
    :show-arrow="false" trigger="hover"
    :popper-class="['c-header-popper', theme || injectTheme || routeTheme]" placement="bottom" :popper-style="{width: 'auto'}"
    @show="showAssets = true"
    @hide="showAssets = false"
  >
    <template #reference>
      <li
        :class="{ '!c-[--primary-500]': showAssets }"
        class="flex items-center mr-24px c-[--gray-700] cursor-pointer text-sm-m dark:c-[--gray-25]"
      >
        {{ $t('充值') }}
        <base-icon
          name="menu-down"
          class="ml-6px text-8px transition-transform duration-300"
          :class="{ 'rotate-180': showAssets }"
        />
      </li>
    </template>
    <div class="deposit-warp">
      <template v-for="(item, index) in depositList" :key="index">
        <div v-if="item.show" class="deposit-inner hk-header-color-3 text-sm-m" @click="gotoUrl(item.link, item.text)">
          <ExIconFaitDeposit v-if="index===0" class="hk-header-color-3" />
          <ExIconCryptoCurrency v-if="index===1" class="hk-header-color-3" />
          <ExIconCurrencyExchange v-if="index===2" class="hk-header-color-3" />
          <div class="ml12">
            {{ item.text }}
          </div>
        </div>
      </template>
    </div>
  </el-popover>
</template>

<script setup lang="ts">
import { useUserStore } from '@/store/User';
import { useAssetsStore } from '@/store/assets';
import BaseIcon from '@c/common/Icon.vue';

const showExchangeBtn = ref<boolean>(false);
const showAssets = ref(false);
defineProps({
  theme: {
    type: String,
    default: ''
  }
});
const assetsStore = useAssetsStore();
const userStore = useUserStore();
const injectTheme = inject('theme');
const router = useRouter();
const route = useRoute();
const routeTheme = computed(() => {
  const routeProps: any = route.meta.props;
  return routeProps?.header?.theme;
});

const { t } = useI18n();

// 换汇按钮是否展示
// const getExchangeBtnStatus = async() => {
//   const res = await exchangeApi.getExchangeInfo();
//   // enterStatus所有数据为2时，则不展示
//   if (res?.code == 0 && res?.data?.find(x => x.enterStatus != 2)) {
//     showExchangeBtn.value = true;
//   } else {
//     showExchangeBtn.value = false;
//   }
// };

// // 换汇权限
// const fxPermission = computed(() => {
//   if (userStore.isAuthorizedAdmin) {
//     // 授权管理员 使用 返回权限判定
//     const fxHkd = userStore?.permissions?.find((item: any) => item?.permKey == 'fx.hkd.forbidden') || {};
//     const fxUsd = userStore?.permissions?.find((item: any) => item?.permKey == 'fx.usd.forbidden') || {};
//     return (fxHkd?.hasPermission || fxUsd?.hasPermission) && showExchangeBtn.value;
//   } else {
//     return showExchangeBtn.value;
//   }
// });

// 数币充值权限
// omnibus没有存管账户,所以不展示充值入口
const userTypeSupport = computed(() => {
  // if (userStore.isAuthorizedAdmin) {
  //   // 授权管理员根据返回权限控制限制  展示数币充值入口：先要有存管账户，再有充值权限
  //   const custody = userStore?.permissions?.find((item: any) => item?.permKey == 'custody') || {};
  //   return custody?.hasPermission && !userStore?.userinfo?.riskSettings?.disallowTokenDeposit;
  // }
  if (userStore?.userinfo?.userType == 4 && userStore?.userinfo?.etfType == 0) {
    // 普通 omnibus 没有存管账户，不展示数币充值入口, PD Omnibus 是有存管账户的
    return false;
  }
  return true;
});

// // 法币充值权限
// const fiatDepositPermission = computed(() => {
//   if (userStore.isAuthorizedAdmin) {
//     // 授权管理员根据返回权限控制限制  展示数币充值入口：先要有存管账户，再有充值权限
//     const fiat = userStore?.permissions?.find((item: any) => item?.permKey == 'fiat') || {};
//     return fiat?.hasPermission && !userStore?.userinfo?.riskSettings?.disallowFiatDeposit;
//   }
//   return true;
// });

const depositList = computed(() => {
  return [
    { link: '/custody/assetView/fiatAccount/deposit', text: t('法币充值'), show: !userStore?.userinfo?.riskSettings?.disallowFiatDeposit }, // 用户无充值权限时，不展示法币入口
    { link: '/custody/assetView/savingAccount/deposit', text: t('数字货币充值'), show: userTypeSupport.value }
    // HKEX-11088 开放货币兑换入口
    // { link: '/currency-converter', text: t('货币兑换'), show: showExchangeBtn.value }
  ];
});

const gotoUrl = (url:string, text:string) => {
  // 重构法币充值，不需要获取充值渠道
  router.push(url);

  // // 法币充值需要获取渠道列表
  // if (text == "法币充值" && assetsStore.fiatChannelSupports?.length > 0) {
  //   const channel = assetsStore.fiatChannelSupports?.[0]?.channel;
  //   router.push(`/custody/assetView/fiatAccount/deposit/quickTransfer?channel=${channel}`);
  // } else{
  //   router.push(url);
  // }
};

onMounted(async() => {
  await assetsStore.getFiatChannelList();
  // getExchangeBtnStatus();
});

</script>

<style lang="scss" scoped>
.deposit-warp {
  padding: 12px;
  // width: 180px;

  .deposit-inner {
    padding: 12px 8px;
    display: flex;
    align-items: center;
    cursor: pointer;
    &:hover {
      border-radius: 8px;
      background: var(--hk-header-color-4);
    }

  }
}
</style>
